const enums = {
  itineraryStatus: {
    BOOKED: 'booked',
    PARTIALLY_BOOKING: 'partial',
  },
  railSeatPreference: {
    OPTIONAL: 'NR',
    MANDATORY: 'SA',
    AUTO: 'AA',
  },
  railSeatPreferenceTypes: {
    POSITION: 'SeatReservationPosition',
    DIRECTION: 'SeatReservationDirection',
    COACH_TYPE: 'SeatReservationCoachType',
    ATTRIBUTE: 'SeatReservationPreferenceAttribute',
  },
  itinerarySearchTypes: {
    BLACK_CAR_SEARCH: 1,
    CAR_SEARCH: 2,
    FLIGHT_SEARCH: 3,
    HOTEL_SEARCH: 4,
  },
  dateTimeFormats: {
    DATE_SHORT: 1,
    DATE_MEDIUM: 2,
    DATE_LONG: 3,
    TIME_LONG: 4,
    DATE_TIME_LONG: 5,
  },
  itineraryCreationType: {
    Created: 0,
    Modification: 1,
  },
  paymentTypes:{
    INVOICE: 'Invoice',
    NOCARD: 'NoCard',
  },
};

export default enums;



// WEBPACK FOOTER //
// ./src/constants/enums.js